module.exports = __webpack_public_path__ + "img/hags-hovel.b872ef19.jpg";